import React from 'react'

import Color from '../Video/Timelapse.mp4'
import Black from '../Video/Backgorund.mp4'
import { Paragraph, Pane, SideSheet, Heading, Card, Button } from 'evergreen-ui'
import Component from '@reactions/component'
import Me from '../Assets/Me.PNG';
function AboutPage(props) {
  return(

    <div className="App">
          <video
            autoPlay
            loop
            muted
            style={{
              position: "absolute",
              width: "100%",
              left: "50%",
              top: "50%",
              height: "100%",
              objectFit: "cover",
              transform: "translate(-50%, -50%)",
              zIndex: "-1"
            }}
          >
        <source src ={Black} type="video/mp4" />

        </video>,
    <Pane clearfix>

    <Pane
    background="transparent"
    elevation={0}
    float="left"
    width={600}
    height={100}
    marginX={200}
    marginY={100}
    display="flex"
    justifyContent="center"
    alignItems="center"
    flexDirection="column"
    >
    <Paragraph size={900}  color="goldenrod" marginTop="default">
    My name is Ryan Kidd and I am a second year student attending the Interactive Arts and Science program at Brock University. I am currently focusing my studies on level design with an interest in front-end web development. I have taught myself how to code in React and have created multiple small scale levels throughout my time at Brock.
    </Paragraph>



    </Pane>
    </Pane>
    <Pane

    float="right"
    height={170}
    width={530}
    display="flex"
    alignItems="center"
    paddingX={0}
    >
    <img src={Me}  />
    </Pane>


    </div>
  )
}
export default AboutPage;
